import { BackendHttpService } from "../../../../../services/backendHttpService";
import { ProfileCompletionRulesFaqDto } from "../models/profileCompletionRulesFaq.model";

export class ProfileCompletionFaqService extends BackendHttpService {
    constructor() {
        super("ProfileCompletion");
    }

    async getRules(): Promise<ProfileCompletionRulesFaqDto> {
        return this.get<ProfileCompletionRulesFaqDto>("/rules");
    }
}

export const profileCompletionFaqService = new ProfileCompletionFaqService();
